module.exports = __webpack_public_path__ + "WealthCare Saver HSA Investments Quick Start Guide.pdf";